import type {SignupStepInputInput} from 'gql/types';

import {usePerformSignupStepMutation} from './signUp.queries.generated';

export function usePerformSignupStep() {
  const [performSignupStep] = usePerformSignupStepMutation();
  return (step: SignupStepInputInput) =>
    performSignupStep({
      variables: {input: {input: step}},
      refetchQueries: ['currentUserPendingTasks'],
      awaitRefetchQueries: true
    });
}
